import React, { useEffect, useState, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSetRecoilState } from "recoil";
import { modalState } from "recoil/modal/atom";

const ModalComponent = ({ modalData }) => {
  const data = modalData && modalData?.[0];
  const [show, setShow] = useState<any>(false);
  const setModalState = useSetRecoilState(modalState);

  // Memoized close handler to prevent unnecessary re-renders
  const handleClose = useCallback(() => {
    if (data?.onHide) {
      data.onHide();
    }
    setModalState([]);
    setShow(false);
  }, [data?.onHide, setModalState]);

  // Update show state when modal data changes
  useEffect(() => {
    setShow(data?.show || false);
  }, [data?.show]);

  // Early return if no modal data
  if (!data) {
    return null;
  }

  const {
    title,
    children,
    fullScreen,
    centered,
    size,
    dialogClassName,
    className,
    closeButton = false, // Default to true
    // showFooter = true
  } = data;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      fullscreen={fullScreen}
      centered={centered}
      size={!fullScreen ? size : undefined}
      dialogClassName={dialogClassName}
      className={className}
    >
      <Modal.Header closeButton={true} className="brand-primary">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {show && children}
      </Modal.Body>

      {/* Show footer button only when header close button is disabled or explicitly requested */}
      {(closeButton === true) && (
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default React.memo(ModalComponent);
